import styled from "styled-components";


export const LayoutContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    background-color: ${({ theme }) => theme.color};
`

export const LayoutDevelopment = styled.div`
    display: grid;
    grid-template-areas: 'sidebar header'
    'sidebar main';
    grid-template-columns: auto 1fr;
    width: 100vw;
    height: 100vh;
    grid-template-rows: 50px 1fr;
    background-color: ${({ theme }) => theme.color};

`


export const ContainerConteudos = styled.section`
  position: relative;
  display: flex;
  width: 100%;
  height: calc(100% - 80px);
  background-color: ${({ theme }) => theme.color};
`
